import { get, set } from 'lodash';
import { ANTRAGS_FORMULAREN, VORHABENS_ART } from 'src/lib/constants/constant';
import { generateUniqueId, getFieldNamefromDataPath } from 'src/utils/helper';
import { getGeneralAppData } from './GetGeneralAppData';

// import Schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import OrgaSchema from 'src/lib/paths/organisation_FULL_Paths.json';
const P = AntragSchema.attributes;
const OP_P = OrgaSchema.attributes;

export const getAppData = (
	programId: number,
	programmDetails: any,
	orgaId: number,
	orgaDetails: any,
	antragsDetails: any,
	alleAntragberechtigte?: any,
) => {
	const generalAppData = getGeneralAppData(
		programmDetails,
		programId,
		get(antragsDetails, 'Antragsformular', ''),
		get(antragsDetails, 'AntragsTyp', ''),
		orgaDetails,
		orgaId,
		alleAntragberechtigte,
		get(antragsDetails, getFieldNamefromDataPath(P.Allgemein_Art_Des_Antrags.path)),
	);

	const antragFormular = get(antragsDetails, 'Antragsformular');
	switch (antragFormular) {
		case ANTRAGS_FORMULAREN.EmobInvest:
			return { ...generalAppData, ...getEmobInvestAppData() };
		case ANTRAGS_FORMULAREN.EmobLis:
			return { ...generalAppData, ...getEmobLisAppData(orgaDetails) };
		case ANTRAGS_FORMULAREN.Messefoerderung:
			return { ...generalAppData, ...getMesseFoerderAppData() };
		case ANTRAGS_FORMULAREN.StartUpProjekte:
			return { ...generalAppData };
		case ANTRAGS_FORMULAREN.Mobilitaetsplaene:
			return { ...generalAppData, ...getMobilitaetsplaeneAppData(antragsDetails) };
		case ANTRAGS_FORMULAREN.Loewe:
			return { ...generalAppData, ...getLoeweAppData(orgaId) };
		case ANTRAGS_FORMULAREN.Elektrobusse:
			return { ...generalAppData, ...getEBusseAppData(antragsDetails) };
		case ANTRAGS_FORMULAREN.Entwicklungszusammenarbeit:
			return { ...generalAppData, ...getEpzAppData(orgaDetails) };
		case ANTRAGS_FORMULAREN.StartUpStipendium:
			return { ...generalAppData, ...getStipendiumAppData(orgaDetails) };
		default:
			return generalAppData;
	}
};

const getEmobInvestAppData = () => {
	return {
		Projektbeschreibung_Elektromobilitaet_Invest: {
			Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs: [{ E_45_Nutzfahrzeug: null }],
			Projektbeschreibung_Elek_0231047921_en_Ladeinfrastruktur_Block_1: [{ Zelle_1: null }],
			Projektbeschreibung_Elek_0095548994_est_Ausgangssituation_Bilder: [{ Kurzbeschreibung: '' }],
			Projektbeschreibung_Elek_0112109858_ionen_Elektrofahrzeug_Bilder: [{ Kurzbeschreibung: '' }],
			Projektbeschreibung_Elek_0193290210_nen_Ladeinfrastruktur_Bilder: [{ Kurzbeschreibung: '' }],
			Projektbeschreibung_Elek_0103379282_toff_Betankungsanlage_Bilder: [{ Kurzbeschreibung: '' }],
			Projektbeschreibung_Elek_0220424306_chreibung_Und_Vergabe_Bilder: [{ Kurzbeschreibung: '' }],
			Projektbeschreibung_Elek_0109936114_onstige_Informationen_Bilder: [{ Kurzbeschreibung: '' }],
		},
	};
};
const getMesseFoerderAppData = () => {
	let data = {};
	let angabenLetztenVierJahren = [];
	const currentJahr = new Date().getFullYear();
	for (let i = 0; i < 4; i++) {
		angabenLetztenVierJahren.push({
			Jahr: currentJahr - i,
		});
	}
	return {
		...data,
		Angaben_Zur_Messebeteiligung: {
			Projektbeschreibung_Messefoerderung_Messeteilnahmen: angabenLetztenVierJahren,
		},
	};
};
const getLoeweAppData = (loggedInOrgaID: number) => {
	const uniqueID = generateUniqueId();
	return {
		Allgemein_Vorhabensart: VORHABENS_ART.Verbundvorhaben,
		// Projektbeschreibung erste die Bilder componente anlegen
		Projektbeschreibung_Loewe: {
			Ausgangssituation_Bilder: [{ Kurzbeschreibung: '' }],
			Entwicklungsvorhaben_Bilder: [{ Kurzbeschreibung: '' }],
			Alleinstellungsmerkmale_Bilder: [{ Kurzbeschreibung: '' }],
			Marktanalyse_Bilder: [{ Kurzbeschreibung: '' }],
			Wissenschaftliche_Effekte_Bilder: [{ Kurzbeschreibung: '' }],
			Meilensteinplanung_Bilder: [{ Kurzbeschreibung: '' }],
			Aussendarstellung_Bilder: [{ Kurzbeschreibung: '' }],
			// Selbsterklärung RUS
			Projektuebersicht: [{ Unternehmen: loggedInOrgaID }, { Position_ID: uniqueID }],
		},
		Verbundpartner: [{ Rechtsverbindlicher_Name_Der_Organisation: '', Position_ID: uniqueID, Verbundpartner_Ansprechpartnerin: [{ Vorname: '' }] }],
		Assoziierte_Partner: [{ Rechtsverbindlicher_Name_Der_Organisation: '' }],
		// Selbst Erklärung-KMU
		Selbsterklaerung_KMU: [
			{ Kmu_Unternehmen: loggedInOrgaID, Kmu_Kennzahlen: [{ Kmu_Kennzahlen_Bezugsjahr: null }, { Kmu_Kennzahlen_Bezugsjahr: null }] },
			{ Position_ID: uniqueID, Kmu_Kennzahlen: [{ Kmu_Kennzahlen_Bezugsjahr: null }, { Kmu_Kennzahlen_Bezugsjahr: null }] },
		],
		// Selbsterklärung RUS
		Selbsterklaerung_RUS: [{ Unternehmen: loggedInOrgaID }, { Position_ID: uniqueID }],
		// Anlagen
		Anlagen_Anlagen: [{ Kommentar: '' }],
	};
};
const getMobilitaetsplaeneAppData = (antragDetails: any) => {
	return {
		Projektbeschreibung_Mobilitaetsplaene: {
			Projektbeschreibung_Mobi_0195191031_ng_Gegenstand_Der_Foerderung: antragDetails.GegenStand,
		},
	};
};
const getEBusseAppData = (antragDetails: any) => {
	return {
		Projektbeschreibung_Elektrobusse: {
			Gegenstand_Der_Foerderung: antragDetails.GegenStand,
		},
	};
};
const getEpzAppData = (_orgaDetails: any) => {
	return {
		Projektbeschreibung_Entwicklungszusammenarbeit: {
			Name_Der_Partnerorganisation: '',
		},
	};
};
const getEmobLisAppData = (orgaDetails: any) => {
	const projektAkronym = `${get(orgaDetails, OP_P.Geschaeftsbezogene_Daten_Kuerzel.path, '')} LISS25`;
	return {
		[getFieldNamefromDataPath(P.Allgemein_Kurzwort.path)]: projektAkronym.slice(0, 12).replace(/-$/, ''),
		[getFieldNamefromDataPath(P.Projektbeschreibung_Elektromobilitaet_LIS.path)]: {
			[getFieldNamefromDataPath(P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.path)]: [
				{
					[getFieldNamefromDataPath(
						P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.schema.attributes.Group_45_ID
							.path,
					)]: generateUniqueId(),
					[getFieldNamefromDataPath(
						P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.schema.attributes
							.Darlegung_Block.path,
					)]: [{ Zelle_1: '' }],
				},
			],
		},
	};
};

const getStipendiumAppData = (orgaDetails: any) => {
	let result = {};
	const gruendungsdatum = get(orgaDetails, OP_P.Unternehmensprofil_Gruendungsdatum.path, null);
	const isGruendungsdatumNotInFuture = gruendungsdatum && new Date(gruendungsdatum) <= new Date();
	const stipendiumKey = getFieldNamefromDataPath(P.Projektbeschreibung_Startup_Stipendium.path);

	if (isGruendungsdatumNotInFuture) {
		set(result, stipendiumKey, {
			[getFieldNamefromDataPath(
				P.Projektbeschreibung_Startup_Stipendium.schema.attributes.Projektbeschreibung_Startup_Stipendium_Gruendung_Bereits_Erfolgt.path,
			)]: true,
			[getFieldNamefromDataPath(
				P.Projektbeschreibung_Startup_Stipendium.schema.attributes.Projektbeschreibung_Startup_Stipendium_Unternehmensgruendung_Am.path,
			)]: gruendungsdatum,
		});
	} else if (gruendungsdatum && !isGruendungsdatumNotInFuture) {
		set(result, stipendiumKey, {
			[getFieldNamefromDataPath(
				P.Projektbeschreibung_Startup_Stipendium.schema.attributes.Projektbeschreibung_Startup_Stipendium_Gruendung_Bereits_Erfolgt.path,
			)]: false,
		});
	} else {
		set(result, stipendiumKey, {
			[getFieldNamefromDataPath(
				P.Projektbeschreibung_Startup_Stipendium.schema.attributes.Projektbeschreibung_Startup_Stipendium_Gruendung_Bereits_Erfolgt.path,
			)]: null,
		});
	}

	// Merge with existing object at the key instead of overwriting
	const existing: any = get(result, stipendiumKey, {});
	set(result, stipendiumKey, {
		...existing,
		[getFieldNamefromDataPath(
			P.Projektbeschreibung_Startup_Stipendium.schema.attributes.Projektbeschreibung_Star_0070459294_ngen_Auf_Dem_Markt_Angeboten.path,
		)]: null,
	});

	set(
		result,
		[getFieldNamefromDataPath(P.Antragstellende_Organisation_Ansprechpartnerin.path)],
		[
			{
				[getFieldNamefromDataPath(P.Antragstellende_Organisation_Ansprechpartnerin.schema.attributes.Vorname.path)]: '',
			},
		],
	);
	return result;
};
